export const SpinnerSelectors = {
    IsOpen: (state) => state.Spinner.isOpen,
    Options: (state) => state.Spinner.options,
};
